<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <!--<h3>Error {{ code }}</h3>-->
    <label class="generalLabel" id="mensajeError" for="vendorCheck">{{ message }}</label>
    <v-icon id="iconoError" name="md-erroroutline" scale="6.5" />
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal"
      aria-label="Close">Cerrar</button>
  </Modal>
</template>

<script>
import Modal from '../Shared/Modal.vue';
export default {
  name: 'ModalError',
  props: [
    'id',
    'modalTitle',
    'class',
    'message',
    'code'
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#iconoError {
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  top: 0;
  color: rgba(131, 131, 131, 0.052);
}

#mensajeError {
  position: relative;
  z-index: 999;
}
</style>
